'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardLoginsResponse(total, errors, rate, hosts, hostStats, systemStats, topUsers, topAccounts, sign) {
  this.xq = 0;
  this.DB = 0;
  this.DD = 0.0;
  this.DC = null;
  this.xo = null;
  this.xp = null;
  this.DG = null;
  this.DF = null;
  this.DE = null;
  this.xq = total;
  this.DB = errors;
  this.DD = rate;
  this.DC = hosts;
  this.xo = hostStats;
  this.xp = systemStats;
  this.DG = topUsers;
  this.DF = topAccounts;
  this.DE = sign;
}
export { $c_Lpresto_types$DashboardLoginsResponse as $c_Lpresto_types$DashboardLoginsResponse };
$p = $c_Lpresto_types$DashboardLoginsResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardLoginsResponse;
/** @constructor */
function $h_Lpresto_types$DashboardLoginsResponse() {
}
export { $h_Lpresto_types$DashboardLoginsResponse as $h_Lpresto_types$DashboardLoginsResponse };
$h_Lpresto_types$DashboardLoginsResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DashboardLoginsResponse"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.xq);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.DB);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().gV(this.DD));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.DC));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.xo));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.xp));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.DG));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.DF));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.DE));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 9);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$DashboardLoginsResponse)) {
    if ((((this.xq === x$0.xq) && (this.DB === x$0.DB)) && (this.DD === x$0.DD))) {
      var x = this.DC;
      var x$2 = x$0.DC;
      var $x_5 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$3 = this.xo;
      var x$4 = x$0.xo;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.xp;
      var x$6 = x$0.xp;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.DG;
      var x$8 = x$0.DG;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.DF;
      var x$10 = x$0.DF;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.DE;
      var x$12 = x$0.DE;
      return ((x$11 === null) ? (x$12 === null) : x$11.i(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 9;
});
$p.s = (function() {
  return "DashboardLoginsResponse";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.xq;
      break;
    }
    case 1: {
      return this.DB;
      break;
    }
    case 2: {
      return this.DD;
      break;
    }
    case 3: {
      return this.DC;
      break;
    }
    case 4: {
      return this.xo;
      break;
    }
    case 5: {
      return this.xp;
      break;
    }
    case 6: {
      return this.DG;
      break;
    }
    case 7: {
      return this.DF;
      break;
    }
    case 8: {
      return this.DE;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$DashboardLoginsResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jF)));
}
export { $isArrayOf_Lpresto_types$DashboardLoginsResponse as $isArrayOf_Lpresto_types$DashboardLoginsResponse };
var $d_Lpresto_types$DashboardLoginsResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardLoginsResponse, "presto.types$DashboardLoginsResponse", ({
  jF: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardLoginsResponse as $d_Lpresto_types$DashboardLoginsResponse };
//# sourceMappingURL=presto.types$-Dashboard-Logins-Response.js.map
